export default {
  "title": "FreeDive Ai",
  "heroHeadline": "매일 훈련하고 프리다이빙 실력을 향상시키세요!",
  "heroSubheadline": "프리다이버, 스피어피셔, 머메이드를 위한 최고의 AI 이퀄라이징 및 숨참기 훈련 앱입니다.",
  "featuresHeader": "왜 FreeDive Ai 인가요?",
  "featuresSubtitle": "더 깊이 잠수하고, 더 오래 숨을 참고, 안전하게 다이빙하기 위한 모든 것.",
  "feature1Title": "AI Apnea 훈련",
  "feature1Desc": "개인 최고 기록을 기반으로 AI가 맞춤형 CO2 및 O2 테이블을 생성하여 안전하게 숨참기 시간을 늘려줍니다.",
  "feature2Title": "스마트 로그북",
  "feature2Desc": "프리다이빙과 스피어피싱 세션을 기록하세요. 수심, 시간, 심박수, 산소포화도를 한곳에서 관리할 수 있습니다.",
  "feature3Title": "대회 및 라이센스",
  "feature3Desc": "프리다이빙 자격증을 관리하고 전 세계 대회 및 이벤트 소식을 빠르게 받아보세요.",
  "screenshotsTitle": "앱 스크린샷",
  "copyright": "© DomiLabs. All rights reserved."
};
